export const ActionTypes = {
   GET_BRANDS: 'BRAND/GET_BRANDS'
}
